import moment from "moment";

export const date_to_display = (date) => {
  const currentDate = moment();
  const givenDate = moment(date);

  if (givenDate.isSame(currentDate, "day")) {
    return moment(date).format("hh:mm A"); // Show time only
  }
  if (givenDate.isAfter(currentDate.clone().subtract(1, "week"))) {
    return moment(date).format("dddd"); // Show day only
  }

  return moment(date).format("YYYY-MM-DD");
};

export const date_to_display_for_messages = (date) => {
  const currentDate = moment();
  const givenDate = moment(date);

  // Check if the given date is today
  if (givenDate.isSame(currentDate, "day")) {
    return moment(date).format("hh:mm A"); // Show time only
  }

  // Check if the given date is within the previous week
  if (givenDate.isAfter(currentDate.clone().subtract(1, "week"))) {
    return moment(date).format("dddd [at] hh:mm A"); // Show day only
  }

  return moment(date).format("YYYY-MM-DD [at] hh:mm A");
};

export const scroll_to_bottom_on_message = (is_quick_move) => {
  const chat_box = document.getElementById("chat-box-body");
  setTimeout(() => {
    if (chat_box) {
      if (is_quick_move) {
        chat_box.scrollTop = chat_box.scrollHeight;
      } else {
        chat_box.scroll({ top: chat_box.scrollHeight, behavior: "smooth" });
      }
    }
  }, 30);
};

export function filter_chats(
  conversationsList,
  userInfo,
  query,
  filterType,
  onlineType
) {
  let dataToFilter = [...conversationsList];

  // Step 1: Apply filter based on filterType
  // if (filterType === "unread") {
  //   dataToFilter = dataToFilter.filter((conversation) => {
  //     const currentUser = conversation.members.find(
  //       (user) => user._id === userInfo._id
  //     );
  //     return currentUser?.unread_message_count > 0;
  //   });
  // } else if (filterType === "favorites") {
  //   dataToFilter = dataToFilter.filter(
  //     (conversation) => conversation.is_favorite === true
  //   );
  // } else if (filterType === "calls") {
  //   dataToFilter = dataToFilter.filter(
  //     (conversation) => conversation.last_message?.message_type === "call"
  //   );
  // }

  // if (onlineType === "online") {
  //   dataToFilter = dataToFilter.filter((conversation) =>
  //     conversation.members.find(
  //       (member) => member.user_type === "student" && member.is_online === true
  //     )
  //   );
  // }

  // Step 2: Apply search query filter
  // if (query) {
  //   dataToFilter = dataToFilter.filter((conversation) =>
  //     conversation.members.some(
  //       (member) =>
  //         member.user_type === "student" &&
  //         member.name.toLowerCase().includes(query.toLowerCase())
  //     )
  //   );
  // }

  // Step 3: Sort by favorites and createdAt
  const sortedConversations = dataToFilter.sort((a, b) => {
    // First sort by is_favorite (favorites first)
    // if (a.is_favorite && !b.is_favorite) return -1;
    // if (!a.is_favorite && b.is_favorite) return 1;

    // Then sort by date (newest first)
    const createdAtA = new Date(a.message_created_at || a.created_at);
    const createdAtB = new Date(b.message_created_at || b.created_at);
    return createdAtB - createdAtA;
  });

  return sortedConversations;
}

export const get_short_string = (str, limit = 30) => {
  return str && str.length < limit ? str : str?.slice(0, limit) + "...";
};
